import analytics from '../../../modules/analytics';
import { useSnackbar } from '../../../hooks';
import { ShareTarget } from '../../../modules/share';
import { createClientReferralPopoverSnackbarProps } from '../incentives/ClientReferralPopover';
import { useReferralLanding } from './useReferralLanding';

type ReferralSnackbarEvents = {
  view_id: string;
  click_id: string;
  dismiss_id: string;
};

export function useShowReferralLandingIfNeeded(
  payload: {
    target: ShareTarget;
    providerId?: number;
  },
  events: ReferralSnackbarEvents,
  onClick: () => void,
) {
  const {
    open: openSnackbar,
    close: closeSnackbar,
  } = useSnackbar();

  return useReferralLanding(payload, () => {
    const snackbarProps = createClientReferralPopoverSnackbarProps({
      onClick: () => {
        analytics.track(events.click_id);
        onClick();
        closeSnackbar();
      },
      onClose: () => {
        analytics.track(events.dismiss_id);
        closeSnackbar();
      },
    });

    openSnackbar({ ...snackbarProps, timeOut: 10000 });

    analytics.track(events.view_id);
  });
}
